import { CONTENT_PROPERTIES, fetchCmpObjectsByType } from 'personalization-lib/api/clients/cmpApiClient';
import { PERSONALIZATION_STATUS } from 'personalization-lib/constants/status';
import { notHasProperty, propertyEquals, propertyNotEquals } from 'personalization-lib/utils/assetData/cmp';
import { WEBSITE_PAGES_URL } from 'personalization-lib/constants/urls';
import { fetchContentById } from 'personalization-lib/api/clients/contentApiClient';
export const fetchWebsitePage = id => fetchContentById({
  url: WEBSITE_PAGES_URL,
  id
});
export const WP_FILTERS = [notHasProperty(CONTENT_PROPERTIES.VARIATION), notHasProperty(CONTENT_PROPERTIES.AB_STATUS), notHasProperty(CONTENT_PROPERTIES.PERSONALIZATION_STRATEGY_ID), propertyNotEquals(CONTENT_PROPERTIES.PERSONALIZATION_VARIANT_STATUS, PERSONALIZATION_STATUS.VARIANT), propertyEquals(CONTENT_PROPERTIES.AUDIENCE_ACCESS, 'PUBLIC')];
export const fetchWebsitePagesOptions = paginationParams => fetchCmpObjectsByType(Object.assign({
  objectType: 'SITE_PAGE',
  filters: WP_FILTERS
}, paginationParams)).then(cmpPaginatedSearch => ({
  total: cmpPaginatedSearch.total,
  results: cmpPaginatedSearch.results.map(asset => ({
    text: asset.name,
    value: asset.id.toString(),
    screenshot: asset.imgSrc
  })),
  offset: cmpPaginatedSearch.offset
}));